import { FunctionComponent } from 'preact';
import classNames from 'classnames';
import { MouseEventHandler } from 'preact/compat';

import { Typography } from '../Typography/Typography';
import { Button, ButtonProps } from '../Button/Button';
import { useViewportType } from '../../hooks/useViewportType';
import { useIcons } from '../../hooks/useIcons';

export interface AdLinkProps {
  url?: string;
  label: string | React.JSX.Element;
  text?: string | React.JSX.Element;
  handleAdLinkClick?: MouseEventHandler<HTMLElement>;
  className?: string;
  size?: ButtonProps['size'];
  fontSize?: 'small' | 'medium' | 'large';
}

export const AdLink: FunctionComponent<AdLinkProps> = ({
  url,
  label,
  text,
  handleAdLinkClick,
  className,
  size,
  fontSize,
}) => {
  const { isMobile } = useViewportType();
  const { OpenExternal } = useIcons();

  return (
    <Button
      startIcon={<OpenExternal />}
      color="video"
      component="a"
      size={size || (isMobile ? 'medium' : 'large')}
      href={url}
      onClick={handleAdLinkClick}
      target="_blank"
      className={classNames('vgp-ad-link-button', className)}
      rel="noopener nofollow noreferrer"
    >
      <div className="vgp-ad-link-content">
        <Typography
          variant="label"
          size={fontSize || (isMobile ? 'medium' : 'large')}
          color="white"
          className="vgp-ad-link-header"
        >
          {label}
        </Typography>
        {text && (
          <Typography variant="label" size="small" color="white">
            {text}
          </Typography>
        )}
      </div>
    </Button>
  );
};
